<app-modal *ngIf="vo$ | async; let vo">
	<div
		modal-body
		class="app-grouping-tag-confirmation-popup">

		<ng-container [ngSwitch]="vo.action">
			<ng-container *ngSwitchCase="GroupingTagAction.Delete">
				<!-- alert info -->
				<dc-alert
					*ngIf="!vo.isMultipleElement" type="error" message="info"
					i18n-message="@@groupingTag.action.confirmation.popup.delete.info"></dc-alert>
				<dc-alert
					*ngIf="vo.isMultipleElement" type="error" message="multiple-info"
					i18n-message="@@groupingTag.action.confirmation.popup.delete.multiple.info"></dc-alert>

				<!-- description request -->
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-grouping-tag-confirmation-popup__description"
					i18n="@@groupingTag.action.confirmation.popup.delete.description">
					deletion-request</span>
				<span
					*ngIf="vo.isMultipleElement"
					class="app-grouping-tag-confirmation-popup__description"
					i18n="@@groupingTag.action.confirmation.popup.delete.multiple.description">
					deletion-multiple-request</span>
			</ng-container>
		</ng-container>

		<div class="app-grouping-tag-confirmation-popup__element">
			<ng-container *ngIf="!vo.isMultipleElement">
				<span
					i18n="@@groupingTag.action.confirmation.popup.concernedElement">
					concerned-element</span>

				<span class="app-grouping-tag-confirmation-popup__element-label">
					{{ vo.element | truncate: 30: 1 : 'end' }}</span>
			</ng-container>

			<ng-container *ngIf="vo.isMultipleElement">
				<span
					i18n="@@groupingTag.action.confirmation.popup.concernedElements">
					concerned-elements</span>

				<div class="app-grouping-tag-confirmation-popup__element-label">
					{{ vo.groupingTagId.length }}
					<span
						i18n="@@groupingTag.action.confirmation.popup.grouping-tags">
						grouping-tags</span>
				</div>
			</ng-container>
		</div>

		<mat-checkbox
			*ngIf="vo.action === GroupingTagAction.Delete"
			id="{{ cmpId }}-confirm-delete-checkbox"
			color="primary"
			[(ngModel)]="confirmDeletion">
				<span
					*ngIf="vo.action === GroupingTagAction.Delete"
					i18n="@@groupingTag.action.confirmation.popup.delete.confirm">
					confirm-delete</span>
		</mat-checkbox>
	</div>

	<div modal-footer  class="app-grouping-tag-confirmation-popup__footer">
		<ng-container [ngSwitch]="vo.action">
			<button
				*ngSwitchCase="GroupingTagAction.Delete"
				id="{{ cmpId }}-delete-btn"
				class="app-grouping-tag-confirmation-popup__footer__btn"
				[color]="'warn'"
				[disabled]="!confirmDeletion"
				(click)="launchAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Delete"></mat-icon>
				<span
					i18n="@@groupingTag.action.confirmation.popup.delete.btn">
					delete</span>
			</button>
		</ng-container>
	</div>
</app-modal>
